<template>
    <div>
        <form @submit.prevent="$emit('filter')" class="mb-6" v-if="withFilters">

            <div class="flex justify-between items-center gap-2">
                <div class="flex-grow">
                    <slot name="filters"></slot>
                </div>

                <button
                    type="submit"
                    class="flex justify-center py-3 h-11 px-6 border border-transparent rounded-md shadow-sm text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 bg-gray-600 hover:bg-gray-700 focus:ring-gray-500"
                >
                    <SearchIcon class="h-5 w-5 text-white" />
                </button>

                <slot name="buttons"></slot>
            </div>

            <slot name="alt-filters"></slot>

        </form>

        <slot name="above-results"></slot>

        <div class="flex flex-col mt-5">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200 table--index">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th
                                        scope="col"
                                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        :class="{
                                            'cursor-pointer whitespace-nowrap max-w-[1px]': sort
                                        }"
                                        v-tooltip="typeof heading === 'object' ? heading.tooltip : heading"
                                        v-for="(heading, key) in headings"
                                        :key="key"
                                        @click="$emit('sort', key, getNewSortDirection(key))"
                                    >
                                        <div class="flex">
                                            <div class="flex-grow truncate" v-html="typeof heading === 'object' ? heading.heading : heading"></div>
                                            <SortAscendingIcon class="inline-block w-4 h-4 ml-1 text-gray-900" v-if="sort && key === sortBy && sortDirection === 'asc'" />
                                            <SortDescendingIcon class="inline-block w-4 h-4 ml-1 text-gray-900" v-if="sort && key === sortBy && sortDirection === 'desc'" />
                                        </div>
                                    </th>

                                    <th scope="col" class="relative px-6 py-3 whitespace-nowrap w-1" v-if="withActions">
                                        <span class="sr-only">{{ __('forms::actions.actions') }}</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">

                                <slot name="results"></slot>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <Pagination :paginator="paginator" v-if="paginator" />

    </div>
</template>

<script>
    import { SearchIcon } from '@heroicons/vue/solid'
    import {SortAscendingIcon, SortDescendingIcon} from "@heroicons/vue/outline";
    import { VTooltip } from 'floating-vue'
    import 'floating-vue/dist/style.css'

    export default {
        components: {
            SearchIcon,
            SortAscendingIcon,
            SortDescendingIcon,
        },
        directives: {
            tooltip: VTooltip,
        },
        props: {
            headings: [Array, Object],
            paginator: Object,
            sort: {
                type: Boolean,
                default: false,
            },
            withFilters: {
                type: Boolean,
                default: true,
            },
            withActions: {
                type: Boolean,
                default: true,
            },
            sortBy: String,
            sortDirection: String,
        },
        methods: {
            getNewSortDirection(key) {
                return key === this.sortBy && this.sortDirection === 'asc'
                    ? 'desc'
                    : 'asc';
            },
        },
    }
</script>
